import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../components/SignIn.vue"
import store from "../store"
import { Auth } from "aws-amplify"

Vue.use(VueRouter)

const routes = [

  {
    path: "/notauthenticated",
    name: "NotAuthenticated",
    component: () => import("../Error.vue"),
  },
//homedashboard
{
  path: "/homedashboard/:id",
  name:"HomeDashboard",
  component: () => import("../views/home.vue"),
},
{
  path: "/r-d",
  name:"Redirection",
  component: () => import("../views/redirection.vue"),
},


  {
    path: "/commonnotauthenticated",
    name: "CommonNotAuthenticated",
    component: () => import("../Error1.vue"),
  },

  {
    path: "/",
    name: "UnloggedHome",
    component: () => import("../unlogged/UnloggedHome.vue"),
  },
  
  {
    path: "/subscribe/:id",
    name: "Subscribe",
    component: () => import("../components/Subscribe.vue"),
  },
  {
    path: '/unsubscribe/:id',
    name: "unsubscribe",
    component: () => import("../components/unsubscribe.vue"),
  },
  {
    path: "/reauth",
    name: "SellerReAuth",
    component: () => import("../views/SellerReAuth.vue"),
  },
  {
    path: "/product",
    name: "Product",
    component: () => import("../unlogged/Product.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../unlogged/About.vue"),
  },
  
  {
    path: "/customerSupport",
    name: "CustomerSupport",
    component: () => import("../CustomerSupport.vue"),
  },
  
  {
    path: "/pricing",
    name: "Pricing",
    component: () => import("../unlogged/Pricing.vue"),
  },
  { path: "/home/:id", name: "Home", component: Home },
  {
    path: "/pricewatch",
    name: "PriceWatchProducts",
    component: () => import("../components/pricewatch/PriceWatchProducts.vue"),
    children: [
      {
        path: "home",
        name:"PriceWatch",
        component: () => import("../components/pricewatch/PriceWatch.vue"),
      },
      {
       // path: "recommendations:jobid",        //recommendations:jobid
        path:"results",
        name: "PriceWatchResults",
        component: () =>
          import(
            "../components/pricewatch/PriceWatchResults.vue"
          ),
      },
      {
        path:"addproducts/:id",
        name:"AddProducts",
        component: () => import("../components/pricewatch/AddProducts.vue"),
      },
      {
        path:"analytics/:id",
        name:"analytics",
        component:()=>import("../components/pricewatch/Analytics.vue"),
      },
      {
        path:"notification/:id",
        name:"notification",
        component:()=>import("../components/pricewatch/Notification.vue"),
      },
      {
        path:'dashboard/:id' ,
        name:"Dashboard",
        component:()=>import("../components/pricewatch/Dashboard.vue"),
      },
      // {
      //   path:"dashboard",
      //   name:"Dashboard",
      //   component: () => import("../components/pricewatch/Dashboard.vue"),
      // },
      {
        path:"product/:id",
        name:"Product",
        component: () => import("../components/pricewatch/Product.vue"),
      },
      {
        path: "products/:id",
        name: "Products",
        component: () => import("../components/pricewatch/Products.vue"),
      },
      {
        path: "profit",
        name: "PriceWatchProfit",
        component: () => import("../components/pricewatch/PriceWatchProfit.vue"),
      },
      {
        path: "marketshare",
        name: "PriceWatchMarketShare",
        component: () => import("../components/pricewatch/PriceWatchMarketShare.vue"),
      },
      {
        path: "resultshistory/:id",
        name: "PriceWatchResultHistory",
        component: () =>
          import("../components/pricewatch/ResultHistory.vue"),
      },
      {
        path: "/pricewatch/competitors",
        name: "PricewatchCompetitors",
        component: () => import("../components/pricewatch/Competitors.vue"),
      },
      {
        path: "/pricewatch/pricecomparison",
        name: "PricewatchPriceComparison",
        component: () => import("../components/pricewatch/PriceComparison.vue"),
      },
    ],
  },
//{
  {
  path: "/amazonrepricer",
  name:"AmazonRepricer",
  component: () => import("../components/amazonapplication/amazonproducts.vue"),
  children: [
    {
      // path: "recommendations:jobid",        //recommendations:jobid
       path:"connect/:id",
       name: "",
       component: () =>
         import(
           "../components/amazonapplication/amazonconnection.vue"
         ),
     },
    {
     // path: "recommendations:jobid",        //recommendations:jobid
      path:"qsmartsell/:id",
      name: "QsmartSell",
      component: () =>
        import(
          "../components/amazonapplication/AmazonAuthentication.vue"
        ),
    },
    {
      // path: "recommendations:jobid",        //recommendations:jobid
       path:"dashboard/:id",
       name: "Dashboard",
       component: () =>
         import(
           "../components/amazonapplication/Dashboard.vue"
         ),
     },
     {
      // path: "recommendations:jobid",        //recommendations:jobid
       path:"forecast/:id",
       name: "forecast",
       component: () =>
         import(
           "../components/amazonapplication/forecast.vue"
         ),
     },
  ]
},
  /////
  {
    path: "/amazonadoptimization",
    name: "amazonadoptimization",
    component: () => import("../components/amazonadvertisement/amazonadproducts.vue"),
    children: [
      
      {
       // path: "recommendations:jobid",        //recommendations:jobid
        path:"connect/:id",
        name: "Connect",
        component: () =>
          import(
            "../components/amazonadvertisement/amazonadvertisment.vue"
          ),
      },
      {
        // path: "recommendations:jobid",        //recommendations:jobid
         path:"adsummary/:id",
         name: "AdSummary",
         component: () =>
           import(
             "../components/amazonadvertisement/amazonadsummary.vue"
           ),
       },
       {
        // path: "recommendations:jobid",        //recommendations:jobid
         path:"campaignmanager/:id",
         name: "Campaign Manager",
         component: () =>
           import(
             "../components/amazonadvertisement/campaignmanager.vue"
           ),
       },
       {
        path:"adschedule/:id",
        name: "adschedule",
        component: () =>
          import(
            "../components/amazonadvertisement/adSchedule.vue"
          ),
      },
      {
        path:"keywordSearchTerm/:id",
        name: "keywordandSearchTerm",
        component: () =>
          import(
            "../components/amazonadvertisement/keywordandSearchTerm.vue"
          ),
      },
        {
        // path: "recommendations:jobid",        //recommendations:jobid
         path:"automationrules/:id",
         name: "Automation rules",
         component: () =>
           import(
             "../components/amazonadvertisement/automationrules.vue"
           ),
       }, {
        // path: "recommendations:jobid",        //recommendations:jobid
         path:"adperfomacereports/:id",
         name: "Ad Performance Report",
         component: () =>
           import(
             "../components/amazonadvertisement/adperfomancereport.vue"
           ),
       },
       {
        // path: "recommendations:jobid",        //recommendations:jobid
         path:"adperfomacereports/keywordanalysis/:id",
         name: "Keyword Analysis",
         component: () =>
           import(
             "../components/amazonadvertisement/adperformancekeyword.vue"
           ),
       },
      // {
      //   path:"addproducts",
      //   name:"AddProducts",
      //   component: () => import("../components/pricewatch/AddProducts.vue"),
      // },
      // {
      //   path:"analytics",
      //   name:"analytics",
      //   component:()=>import("../components/pricewatch/Analytics.vue"),
      // },
      // {
      //   path:"notification",
      //   name:"notification",
      //   component:()=>import("../components/pricewatch/Notification.vue"),
      // },
      // {
      //   path:"dashboard",
      //   name:"Dashboard",
      //   component:()=>import("../components/pricewatch/Dashboard.vue"),
      // },
      // {
      //   path:"dashboard",
      //   name:"Dashboard",
      //   component: () => import("../components/pricewatch/Dashboard.vue"),
      // },
      // {
      //   path:"product",
      //   name:"Product",
      //   component: () => import("../components/pricewatch/Product.vue"),
      // },
      // {
      //   path: "products",
      //   name: "Products",
      //   component: () => import("../components/pricewatch/Products.vue"),
      // },
      // {
      //   path: "profit",
      //   name: "PriceWatchProfit",
      //   component: () => import("../components/pricewatch/PriceWatchProfit.vue"),
      // },
      // {
      //   path: "marketshare",
      //   name: "PriceWatchMarketShare",
      //   component: () => import("../components/pricewatch/PriceWatchMarketShare.vue"),
      // },
      // {
      //   path: "resultshistory",
      //   name: "PriceWatchResultHistory",
      //   component: () =>
      //     import("../components/pricewatch/ResultHistory.vue"),
      // },
      // {
      //   path: "/pricewatch/competitors",
      //   name: "PricewatchCompetitors",
      //   component: () => import("../components/pricewatch/Competitors.vue"),
      // },
      // {
      //   path: "/pricewatch/pricecomparison",
      //   name: "PricewatchPriceComparison",
      //   component: () => import("../components/pricewatch/PriceComparison.vue"),
      // },
    ],
  },
  /////
  {
    path: "/pricebundle",
    name: "pricebundle",
    component: () =>
      import("../components/pricebundle/PriceBundling.vue"),
      children: [
        {
          path: "/pricebundle/PriceBundlingHome",
          name: "pricebundlinghome",
          component: () => import("../components/pricebundle/PriceBundlingHome.vue"),
        },
        {
          path: "/pricebundle/ProductBased",
          name: "productbased",
          component: () => import("../components/pricebundle/ProductBased.vue"),
        },
        {
          path: "/pricebundle/Products",
          name: "products",
          component: () => import("../components/pricebundle/Products.vue"),
        },
      ],

  },



  {
    path: "/inventoryoptimization",
    name: "InventoryOptimization",
    component: () =>
      import("../components/inventoryoptimization/InventoryOptimizationHome.vue"),
    children: [
    {
        path: "home/:id",
        name: "InventoryOptimizationHome",
        component: () =>
          import("../components/inventoryoptimization/InventoryOptimization.vue"),
     },
    {
      path: "inventory/:id",
      name: "Inventory",
      component: () => import("../components/inventoryoptimization/Inventory.vue"),
        
    },
    {
      path: "inventoryresult/:id",
      name: "InventoryOptimizationHistory",
      component: () =>
        import("../components/inventoryoptimization/ResultHistory.vue"),
    },
    {
      path: "inventoryrecommendations:jobid/:/id",
      name: "Results",
      component: () =>  import("../components/inventoryoptimization/Result.vue"),
       
    },
    {
      path: "inventorysummary/:id",
      name: "InventorySummary",
      component: () =>  import("../components/inventoryoptimization/InventorySummary.vue"),
       
    },
    ],
  },
  {
    path: "/priceoptimization",
    name: "PriceOptimization",
    component: () =>
      import("../components/priceoptimization/PriceOptimization.vue"),
    children: [
      {
        path: "select/:id",
        name: "PriceOptimizationSelect",
        component: () =>
          import("../components/priceoptimization/PriceOptimizationSelect.vue"),
      },
      {
        path: "offline/:id",
        name: "PriceOptimizationOffline",
        component: () =>
          import("../components/priceoptimization/PriceOptimizationOffline.vue"),
      },
      {
        path: "home/:id",
        name: "PriceOptimizationHome",
        component: () =>
          import("../components/priceoptimization/PriceOptimizationHome.vue"),
      },
      {
        path: "revenue/:id",
        name: "Profitmaximization",
        component: () => import("../components/priceoptimization/Product.vue"),
      },
      {
        path: "profit/:id",
        name: "ProfitMaximization",
        component: () => import("../components/priceoptimization/ProfitMaximization.vue"),
      },
      {
        path: "volume/:id",
        name: "VolumeMaximization",
        component: () => import("../components/priceoptimization/VolumeMaximization.vue"),
      },
      {
        path: "resultshistory/:id",
        name: "PriceOptimizationHistory",
        component: () =>
          import("../components/priceoptimization/ResultsHistory.vue"),
      },
      {
        path: "revenue-recommendations:jobid/:id",
        name: "PriceOptimizationResults",
        component: () =>
          import(
            "../components/priceoptimization/PriceOptimizationResults.vue"
          ),
      },
      {
        path: "profit-recommendations:jobid/:id",
        name: "ProfitRecommendation",
        component: () =>
          import(
            "../components/priceoptimization/ProfitRecommendation.vue"
          ),
      },
      {
        path: "volume-recommendations:jobid/:id",
        name: "VolumeRecommendation",
        component: () =>
          import(
            "../components/priceoptimization/VolumeRecommendation.vue"
          ),
      },
      {
        path: "revenue/profit-recommendations/profitsummary/:id",
        name: "ProfitSummary",
        props: true,
        component: () =>
          import("../components/priceoptimization/ProfitSummary.vue"),
      },
      {
        path: "revenue/volume-recommendations/volumesummary/:id",
        name: "VolumeSummary",
        props: true,
        component: () =>
          import("../components/priceoptimization/VolumeSummary.vue"),
      },
      {
        path: "revenue/revenue-recommendations/summary/:id",
        name: "PriceOptimizationSummary",
        props: true,
        component: () =>
          import("../components/priceoptimization/summaryPage.vue"),
      },
    ],
  },
  
  {
    path: "/analytics",
    name: "Analytics",
    component: () => import("../components/analytics/Analytics.vue"),
  },
  {
    path: "/volumerecommendations",
    name: "VolumeRecommendation",
    component: () =>
      import(
        "../components/priceoptimization/VolumeRecommendation.vue"
      ),
      children :[
        {
          path:"volumesummary",
          name:"VolumeSummary",
          component: () =>
            import(
              "../components/priceoptimization/VolumeSummary.vue"
            ),
        },

      ]
  },
  {
    path: "/settings",
    name: "Settings",
    component: () => import("../components/Settings.vue")
  },
  {
    path: "/communication/:id",
    name: "Communication",
    component: () => import("../components/Communication.vue")

  },
  {
    path: "/inviteuser/:id",
    name: "Inviteuser",
    component: () => import("../components/Inviteuser.vue")

  },
 
 
  {
    path: "/shops",
    name: "Shops",
    component: () => import("../components/shop/ShopHome.vue"),
  },
  {
    path: "/SystemAdmin",
    name: "SystemAdmin",
    component: () => import("../components/multi/multi.vue"),
  },
  {
   path: "/home/:id",
    // path:"/home",
    name: "SignIn",
    //component: () => import("../views/Home.vue"),
    component:() => import("../components/SignIn.vue"),
  },
  {
    path: "/forgotPassword",
     // path:"/home",
     name: "ForgotPassword",
     //component: () => import("../views/Home.vue"),
     component:() => import("../components/ForgotPassword.vue"),
   },
   {
    path: "/testing",
    name: "Signup",
    component:() => import("../components/Signup.vue"),


   },
   {
    path: "/existuser",
    name: "Registereduser",
    component:() => import("../components/Registereduser.vue"),

   },
   {
    path: "/enterPassword",
     // path:"/home",
     name: "EnterPassword",
     //component: () => import("../views/Home.vue"),
     component:() => import("../components/EnterPassword.vue"),
   },
  {
    path: "/shop/app",
    name: "ShopHome",
    component: () => import("../components/shop/ShopHome.vue"),
  },
  {
     path:"/privacypolicy",
     name:"PrivacyPolicy",
     component:() => import("../utilities/Components/Card/PrivacyPolicy.vue"),

  },
  {
    path: "/auth/signout",
    name: "SignOut",
    component: () => import("../components/SignOut.vue"),
  },
  {
    path: "/dataSelection",
    name: "DataSelection",
    component: () => import("../components/DataSelection.vue"),
  },
  {
    path:"/privacypolicy",
    name:"PrivacyPolicy",
    component:() => import("../utilities/Components/Card/PrivacyPolicy.vue"),

 },
  {
    path: "/productSelection",
    name: "ProductSelection",
    component: () => import("../components/ProductSelection.vue"),
  },
  {
    path: "/viewModelResults",
    name: "ViewModelResults",
    component: () => import("../components/ViewModelResults.vue"),
  },
 
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

router.beforeResolve((to, from, next) => {
  var unAuthPages =
    to.name == "SignIn" ||
    to.name == "SignOut" ||
    to.name == "UnloggedHome" ||
    to.name == "Product" ||
    to.name == "About" ||
    to.name == "Pricing" ||
    to.name == "ForgotPassword" ||
    to.name == "EnterPassword" ||
    to.name == "PrivacyPolicy" ||
    to.name == "Signup" ||
    to.name == "Registereduser"

  if (unAuthPages) next()
  else {
    Auth.currentAuthenticatedUser()
      .then(() => {
        if (!store.state.signedIn) next({ name: "SignIn" })
        else next()
      })
      .catch(() => {
        next({ name: "SignIn" })
      })
  }
})

export default router